import React from 'react';
import {
  ActionList,
  ChevronDownIcon,
  DropdownButton,
  DropdownOverlay,
  ActionListItem,
  Dropdown,
} from '@razorpay/blade/components';
import { useHistory } from 'react-router-dom';
import { routePaths } from 'components/Routes/data';
import { BulkUploadTypes } from 'constants/bulkUpload';
import useFeature from 'hooks/useFeature';
import useReduxSelector from 'utils/useReduxSelector';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';
import { getContractorText } from 'utils/getContractorText';

export const AddButton = () => {
  const history = useHistory();
  const { isBulkOnboardingFlagEnabled } = useFeature('bulkOnboardingFlag');

  const isRxCurrentAccountMerchant = !!useReduxSelector(loggedInUserSelectors.currentOrganization)
    ?.isRxCurrentAccountMerchant;
  const featureFlags = useReduxSelector(loggedInUserSelectors.features);

  const { contractorTitleCase } = getContractorText({
    isRxCurrentAccountMerchant,
    featureFlags,
  });

  return (
    <Dropdown>
      <DropdownButton variant="primary" icon={ChevronDownIcon} iconPosition="right">
        Add
      </DropdownButton>
      <DropdownOverlay>
        <ActionList>
          <ActionListItem
            onClick={() => {
              history.push(routePaths.employeeOnboarding.employee.basicDetails);
            }}
            title="Employee"
            value="add-employee"
          />
          <ActionListItem
            onClick={() => {
              history.push(routePaths.employeeOnboarding.contractor);
            }}
            title={contractorTitleCase}
            value="add-contractor"
          />
          <ActionListItem
            onClick={() => {
              if (isBulkOnboardingFlagEnabled) {
                history.push({
                  pathname: routePaths.bulkUploads.initiate,
                  search: '?type=' + BulkUploadTypes.TYPE_BULK_ONBOARDING,
                });
              } else {
                window.location.href = routePaths.phpRoutes.bulkOnboarding;
              }
            }}
            title="Multiple Employees"
            value="add-multiple"
          />
        </ActionList>
      </DropdownOverlay>
    </Dropdown>
  );
};
